module.exports = __webpack_public_path__ + "img/b9.27487093.png";